import React from "react";
import "./ProductCard.css";

const ProductCard = ({ product }) => {
  const { stock } = product;

  const totalStock = stock.reduce(
    (acc, item) => acc + parseInt(item.quantity, 10),
    0
  );

  return (
    <div className="product-card">
      <div className="product-image-wrapper">
        {totalStock <= 0 && <div className="sold-out-badge">Sold Out</div>}
        <img
          className="product-img"
          src={`https://riymay.com/assets/${product.images[0]?.url}`}
          alt={product.images[0]?.altText || product.name}
          loading="lazy"
        />
        <div className="product-hover-overlay">
          <button className="quick-shop-btn">Quick Shop</button>
          <div className="sizes-product">
            {product.stock.map((stockItem) => (
              <button
                key={stockItem._id}
                className="size-button-product"
                disabled={stockItem.quantity <= 0}
              >
                {stockItem.size}
              </button>
            ))}
          </div>
        </div>
      </div>

      <div className="product-details">
        <p className="product-card-name">
          {product.name.length > 28
            ? `${product.name.substring(0, 28)}...`
            : product.name}
        </p>
        <p className="product-price">&#8377;{product.price}</p>
      </div>
    </div>
  );
};

export default ProductCard;
